// extracted by mini-css-extract-plugin
export default {"list-item-unselected":"TruckListItem_list-item-unselected__bP16z","list-item-selected":"TruckListItem_list-item-selected__guydx"};